import { isEmpty, isNumber, isObject, isString, toString } from "lodash";
import * as localstorage from "../constants/localstorage";
import { STORAGE_AUTHOR_HASH, STORAGE_TOKEN, STORAGE_USER_ID, STORAGE_USER_PREF } from "../constants/localstorage";
import { clearAllFiles } from "./fileHandler";
import { MigrateStorage } from "./migrage-storage";

export const storagePrefix = "iGap__";

export const getPrefix = (key: string, withPrefix: boolean = true): string => {
  const currentUserPref = window.localStorage.getItem(storagePrefix + STORAGE_USER_PREF);
  if (!withPrefix) {
    return storagePrefix + key;
  } else {
    return storagePrefix + currentUserPref + "__" + key;
  }
  // return withPrefix || userPrefix === 1 ? storagePrefix + key : storagePrefix + `${userPrefix}__` + key;
};

export const migrateStorage = () => {
  /*
  Migrate Version of web LocalStorage
   * 1- userId ("userid" -> userid)
   * 2- authorHash ("authorHash" -> authorHash)
   * 3- authKey ("key" -> key) [STORAGE_TOKEN]
   * */
  // if (getStorage(STORAGE_TOKEN, false)?.startsWith(`"`)) setStorage(STORAGE_TOKEN, JSON.parse(getStorage(STORAGE_TOKEN, false)));
  // if (getStorage(STORAGE_AUTHOR_HASH, false)?.startsWith(`"`)) setStorage(STORAGE_AUTHOR_HASH, JSON.parse(getStorage(STORAGE_AUTHOR_HASH, false)));
  // if (getStorage(STORAGE_USER_ID, false)?.startsWith(`"`)) setStorage(STORAGE_USER_ID, JSON.parse(getStorage(STORAGE_USER_ID, false)));
  new MigrateStorage();
};

export const getStorage = (key: string, withPrefix: boolean = true): any => {
  key = getPrefix(key, withPrefix);
  let value: any = localStorage.getItem(key) || sessionStorage.getItem(key);
  if (isString(value) && ((value.startsWith("[") && value.endsWith("]")) || (value.startsWith("{") && value.endsWith("}")))) {
    value = JSON.parse(value);
  }
  return value;
};

export const setStorage = (key: string, value: any, temp: boolean = false, withPrefix: boolean = true): void => {
  key = getPrefix(key, withPrefix);
  if (!["boolean", "number"].includes(typeof value) && isEmpty(value)) return delStorage(value);
  if (isObject(value) && !(value instanceof Blob)) {
    value = JSON.stringify(value);
  }
  if (isNumber(value)) {
    value = toString(value);
  }
  (temp ? sessionStorage : localStorage).setItem(key, value);
};

export const delStorage = (key: string, withPrefix: boolean = true): void => {
  key = getPrefix(key, withPrefix);
  localStorage.removeItem(key);
  sessionStorage.removeItem(key);
};

export const hasStorage = (key: string, withPrefix: boolean = true): boolean => {
  key = getPrefix(key, withPrefix);
  return localStorage.hasOwnProperty(key) || sessionStorage.hasOwnProperty(key);
};

export const hasStorageKey = (storageKey: string, objectKey: string): boolean => {
  const obj: { [key: string]: any } = getStorage(storageKey);
  return obj && obj.hasOwnProperty(objectKey);
};

export const clearStorages = (): void => {
  Object.values(localstorage).forEach((storage) => delStorage(storage as string));
  clearAllFiles();
  window.localStorage.clear();
};
